<template><div><h1 id="abgleichskandidaten-manuell-bearbeiten" tabindex="-1"><a class="header-anchor" href="#abgleichskandidaten-manuell-bearbeiten"><span>Abgleichskandidaten manuell bearbeiten</span></a></h1>
<p>Adressbereinigung — Abgleichskandidaten manuell bearbeiten</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Ansicht können die Adressen, die zuvor mit diesem Job <RouteLink to="/referenz/refs/ft.refproc.abglkandsuchen.html" title="Abgleichskandidaten suchen">Abgleichskandidaten suchen</RouteLink>, gefundenenen Adressen, hier manuell bereinigt werden.</p>
<p>Pfad: <code v-pre>Personen → Datenpflege → Abgleich mit externer Quelle → Abgleichskandidaten manuell bearbeiten</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>A-Person</dt>
<dd>Zeigt die zu bereinigende Adresse an.</dd>
<dt>Abgleichskandidat</dt>
<dd>Zeigt die Quell-Adresse mit der die A-Person abgeglichen werden kann.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="abgleich-optionen" tabindex="-1"><a class="header-anchor" href="#abgleich-optionen"><span>Abgleich Optionen</span></a></h3>
<dl>
<dt>Personenquelle</dt>
<dd>Personenquelle mit der die Adressen abgeglichen werden.</dd>
<dt>Filternummer</dt>
<dd>Adressfilter, der Abgleich beschränkt sich nur auf die Adressen, die sich in diesem Filter befinden.</dd>
<dt>Zu bereinigende Adressen</dt>
<dd>Mit dieser Einstellung wird definiert, ob postalisch falsche Adressen für die Bereinigung vorgesehen sind, oder alle Adressen.</dd>
<dt>Zu bereinigende Daten</dt>
<dd>Hier wird definiert, welche Adressdaten bereinigt/veredelt werden. Folgende Möglichkeiten stehen zur Auswahl:
<table>
<thead>
<tr>
<th>Auswahl</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>komplette Adressdaten</td>
<td>Alle möglichen Adressdaten wie Vorname, Nachname, Firma, Adresszusatz, Strasse, Hausnummer, Postleitzahl, Ort, Tel., Fax., E-Mail, etc. werden abgeglichen.</td>
</tr>
<tr>
<td>Name</td>
<td>Es werden nur Adressdaten wie Vorname, Nachname, Firma oder Adresszusatz abgeglichen.</td>
</tr>
<tr>
<td>postalische Daten</td>
<td>Es werden nur die postalischen Daten wie Strasse, Hausnummer, Postleitzahl oder Ort abgeglichen.</td>
</tr>
<tr>
<td>Telekommunikationsdaten</td>
<td>Es werden nur die Telekommunikationsdaten wie Tel., Fax. oder E-Mail abgeglichen.</td>
</tr>
<tr>
<td>Treffergenauigkeit</td>
<td>Mit dieser Einstellung wird die Treffergenauigkeit bestimmt. Mit der Einstellung &quot;hoch&quot;, wurden nur eindeutige Abgleichskandidaten gesucht, während bei der Einstellung &quot;tief&quot; auch ähnliche Abgleichskandidaten vorgeschlagen werden können. Z.B. kann die Strasse anders geschrieben sein, die Postleitzahl kann abweichen, der Vorname oder Nachname könnte ev. anders geschrieben sein, aber auch abgekürzte Vornamen wie z.B. &quot;P.Muster&quot; können als Abgleichskandidat vorgeschlagen werden. Bei der Einstellung &quot;mittel&quot; sind leichte Abweichungen möglich.</td>
</tr>
</tbody>
</table>
</dd>
</dl>
<h3 id="bereinigen" tabindex="-1"><a class="header-anchor" href="#bereinigen"><span>bereinigen</span></a></h3>
<p>Die ausgewählte Adresse wird mit dem Abgleichskandidaten aktualisiert.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refproc.abglkandsuchen.html" title="Abgleichskandidaten suchen">Abgleichskandidaten suchen</RouteLink>, <RouteLink to="/referenz/refs/ft.refproc.adrbereinigungaut.html" title="Adressbereinigung automatisch">Adressbereinigung automatisch</RouteLink></p>
</div></template>


